import React from 'react';
import { Like16 as IconSocialLikeOn16, Deslike16 as IconSocialDislikeOn16 } from '@cian/ui-kit';

import { IconWithCount } from '../../../IconWithText';
import * as s from './Likes.css';

export interface ILikes {
  likeCount: number;
  dislikeCount: number;
  isDisabled?: boolean;
  onLikeClick?(e: React.MouseEvent): void;
  onDislikeClick?(e: React.MouseEvent): void;
}

/**
 * Кнопки лайк/дизлайк
 */
export const Likes = ({ likeCount, dislikeCount, isDisabled, onLikeClick, onDislikeClick }: ILikes) => {
  return (
    <div className={s['wrapper']}>
      <IconWithCount
        count={likeCount}
        icon={
          <div className={`${s['icon-wrapper']} ${!isDisabled && onLikeClick ? s['_clickable'] : ''}`}>
            <IconSocialLikeOn16
              onClick={e => {
                if (!onLikeClick || isDisabled) {
                  return;
                }

                onLikeClick(e);
              }}
            />
          </div>
        }
      />

      <IconWithCount
        count={dislikeCount}
        icon={
          <div className={`${s['icon-wrapper']} ${!isDisabled && onDislikeClick ? s['_clickable'] : ''}`}>
            <IconSocialDislikeOn16
              onClick={e => {
                if (!onDislikeClick || isDisabled) {
                  return;
                }

                onDislikeClick(e);
              }}
            />
          </div>
        }
      />
    </div>
  );
};
